"use client";

import { JsonLD } from "@/components/common/json-ld";
import {
  getBreadcrumbItems,
  type BreadcrumbItemData,
} from "@/components/common/location-breadcrumbs";
import type { SearchHookLocation } from "@repo/maps";
import { useTranslations } from "next-intl";

export type BusinessesBreadcrumbsJsonLDProps = {
  countryCode?: string;
  location?: SearchHookLocation;
};

export function BusinessesBreadcrumbsJsonLD({
  countryCode,
  location,
}: BusinessesBreadcrumbsJsonLDProps) {
  const t = useTranslations();

  const items: BreadcrumbItemData[] = [
    { name: t("saas.listing.breadcrumb.home"), pathSegment: "/" },
    ...(getBreadcrumbItems({
      countryCode,
      location,
      basePath: "/businesses/",
    }) ?? []),
  ];

  if (items.length <= 1) {
    return null;
  }

  return (
    <JsonLD
      type="BreadcrumbList"
      breadcrumbs={items.map((item) => ({
        name: item.name,
        item: item.pathSegment ?? "",
      }))}
    />
  );
}
